export default __webpack_public_path__ + "static/media/table-reserved.4f8cd4d2.svg";